export default function TeamSection() {
  const teamMembers = [
    {
      name: 'Sarah Chen',
      role: 'Strategy Director',
      image: 'https://public.readdy.ai/ai/img_res/bcccd8e58beb2463e50291ce64f63eb1.jpg',
      metric: '150+ projects delivered'
    },
    {
      name: 'Michael Torres',
      role: 'Operations Lead',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20man%20consultant%20headshot%20portrait%2C%20clean%20minimal%20background%2C%20confident%20and%20approachable%20expression%2C%20contemporary%20office%20setting%20with%20natural%20lighting&width=300&height=400&seq=team-michael-001&orientation=portrait',
      metric: '40% avg efficiency gain'
    },
    {
      name: 'Emily Watson',
      role: 'Growth Specialist',
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20business%20consultant%20headshot%20portrait%20with%20friendly%20smile%20and%20confident%20posture%2C%20clean%20white%20background%2C%20modern%20professional%20attire%20with%20blazer%2C%20natural%20lighting%20creating%20warm%20and%20approachable%20atmosphere%2C%20experienced%20and%20trustworthy%20demeanor&width=300&height=400&seq=team-emily-003&orientation=portrait',
      metric: '2x revenue growth avg'
    }
  ];

  return (
    <section id="team" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light text-gray-900 mb-4">
            Meet Our Team
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {teamMembers.map((member, index) => (
            <div key={index} className="text-center">
              <div className="mb-6">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-32 h-32 rounded-full mx-auto object-cover object-top mb-4"
                />
                <h3 className="text-xl font-medium text-gray-900 mb-1">
                  {member.name}
                </h3>
                <p className="text-gray-600 font-light mb-3">
                  {member.role}
                </p>
                <p className="text-sm text-gray-500 font-light">
                  {member.metric}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}